import dayjs from "dayjs";

export const DATE_FORMAT = "DD MMM YYYY";
export const DATE_TIME_FORMAT = "DD MMM YYYY, hh:mm A";

/**
 * Formats a date-only value, e.g. "13 Aug 2026".
 * @param value
 * @param fallback
 */
export const formatDate = (value, format = DATE_FORMAT) => (value ? dayjs(value).format(format) : "-");

/**
 * Formats a date+time value, e.g. "13 Aug 2026, 02:30 PM".
 * @param value
 * @param fallback
 */
export const formatDateTime = (value, format = DATE_TIME_FORMAT) => (value ? dayjs(value).format(format) : "-");
